document.addEventListener('DOMContentLoaded', function () {
  // Header dark/light on hero
  const header = document.querySelector('.site-header');
  const hero   = document.querySelector('.hero');
  if (header && hero) {
    header.classList.add('site-header--dark');
    new IntersectionObserver(([e]) => header.classList.toggle('site-header--dark', e.isIntersecting), { threshold: 0.05 }).observe(hero);
  }
  // Cart count
  function refreshCart() {
    fetch('/cart.js').then(r => r.json()).then(c => {
      document.querySelectorAll('.site-header__cart-btn').forEach(el => {
        el.textContent = c.item_count > 0 ? 'Cart (' + c.item_count + ')' : 'Cart';
      });
    });
  }
  refreshCart();
  // Add to cart
  document.querySelectorAll('.js-add-to-cart').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const form = this.closest('form');
      const id   = form ? form.querySelector('[name="id"]').value : this.dataset.variantId;
      if (!id) return;
      const orig = this.textContent;
      this.textContent = 'Adding…'; this.disabled = true;
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id, quantity:1}) })
        .then(() => { refreshCart(); this.textContent = 'Added ✓'; setTimeout(() => { this.textContent = orig; this.disabled = false; }, 1800); })
        .catch(() => { this.textContent = orig; this.disabled = false; });
    });
  });
  // Variant selector
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      this.closest('.product-form__variants').querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const input = this.closest('form')?.querySelector('[name="id"]');
      if (input) input.value = this.dataset.variantId;
      const priceEl = document.querySelector('.product-price');
      if (priceEl && this.dataset.price) priceEl.textContent = '$' + (parseInt(this.dataset.price)/100).toFixed(2);
    });
  });
  // Newsletter
  document.querySelectorAll('.js-newsletter-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = this.querySelector('button[type="submit"]');
      btn.textContent = 'Thank you'; btn.disabled = true;
    });
  });
  // Scroll reveal
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.style.opacity='1'; en.target.style.transform='translateY(0)'; obs.unobserve(en.target); } });
    }, { threshold:0.08 });
    document.querySelectorAll('.statement,.brand-promise,.journal-section,.discovery-band,.collection-header').forEach(el => {
      el.style.cssText += 'opacity:0;transform:translateY(18px);transition:opacity 0.7s ease,transform 0.7s ease;';
      obs.observe(el);
    });
  }
});
